<template>
    <div class="set-password-container">
        <template v-if="isTokenValid">
            <div class="set-password-box" v-if="!passwordWasChanged">
                <h2 class="set-password-box__title" v-html="$t('SetPassword.new_password')"></h2>
                <p class="set-password-box__description" v-html="$t('SetPassword.new_password_info')"></p>

                <TotemPasswordInput :placeholder="$t('SetPassword.enter_your_password')" v-model="$v.model.password.$model" class="set-password-box__input" name="new-password"/>
                <totem-form-finnish-label-error class="error-label" :field="$v.model.password" label=""/>

                <TotemPasswordInput :placeholder="$t('SetPassword.re_enter_your_password')" v-model="$v.model.passwordAgain.$model" class="set-password-box__input" name="new-password-again" />
                <totem-form-finnish-label-error class="error-label" :field="$v.model.passwordAgain" label=""/>

                <TotemButton @click="sendSetNewPasswordRequest" class="set-password-box__button" :disabled="sending" :label="$t('SetPassword.change_password')" />
                <div class="error" v-if="error">{{ error }}</div>
            </div>
            <div class="set-password-box" v-if="passwordWasChanged">
                <h2 class="set-password-box__title" v-html="$t('SetPassword.new_password_changed')"></h2>
                <p class="set-password-box__description" v-html="$t('SetPassword.new_password_changed_info')"></p>
            </div>
        </template>
        <template v-else>
            <div class="set-password-box" v-if="!passwordWasChanged">
                <h2 class="set-password-box__title" v-html="$t('SetPassword.new_password')"></h2>
                <div class="error" v-if="error" v-html="error"></div>
            </div>
        </template>
    </div>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    const { required, sameAs, minLength } = require('vuelidate/lib/validators')
    export default {
        name: 'set-password',
        mixins: [ validationMixin ],
        data () {
            return {
                model: {
                    password: null,
                    passwordAgain: null
                },
                error: null,
                passwordWasChanged: false,
                sending: false,
                isTokenValid: false
            }
        },
        validations: {
            model: {
                password: {
                    required,
                    minLength: minLength(8)
                },
                passwordAgain: {
                    required,
                    repeatPassword: sameAs(function () { return this.model.password })
                }
            },
        },
        methods: {
            async sendSetNewPasswordRequest (e) {
                this.error = null
                this.$v.$touch()
                if (this.$v.$invalid) {
                    e.preventDefault()
                } else {
                    try {
                        this.sending = true
                        await this.$store.dispatch('changePassword', {
                            password: this.model.password,
                            token: this.$route.params.token
                        })
                        this.passwordWasChanged = true
                    } catch (e) {
                        this.sending = false
                        this.error = this.$t('General.sth_went_wrong')
                    }
                }
            }
        },
        async created () {
            try {
                await this.$store.dispatch('checkResetPasswordTokenValidity', this.$route.params.token)
                this.isTokenValid = true
            } catch (e) {
                this.error = this.$t('General.sth_went_wrong')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .error-label {
        text-align: center;
        margin: 0 0 20px;
    }
    .set-password-container {
        padding: 240px 0;
    }
    .set-password-box {
        max-width: 500px;
        display: flex;
        flex-direction: column;
        padding: 20px;
        margin: 0 auto;

        &__input {
            align-self: center;
            margin: 10px 0 0;
        }

        &__button {
            margin: 10px 0 0;
            align-self: center;
        }

        &__title {
            margin: 0 auto;
            padding: 0 0 20px 0;
            font-size: 3rem;
        }
        &__description {
            margin: 0 auto;
            padding: 0 0 20px 0;
            font-size: 1.9rem;
            text-align: center;
        }
    }
    .error {
        color: red;
        align-self: center;
        padding: 10px;
        text-align: center;
    }
</style>
